/**
 * Procedure codes and fees (WP2-CODES): the practice CDT code table,
 * procedure buttons, AutoCode preferences with a live test bench, and fee
 * schedules with office and provider overrides. Clinical modules (chart,
 * treatment plans, perio) reuse `./index.ts` to validate and price entries.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'codes',
    title: 'Procedure codes and fees',
    version: '0.1.0',
    owner: 'WP2-CODES',
    entitlementKey: null,
    permissions: ['chart.view', 'settings.manage', 'money.view'],
    routes: [
      {
        id: 'codes',
        path: '/settings/codes',
        title: 'Procedure codes',
        officeScope: 'practice',
        permission: 'chart.view',
      },
    ],
    nav: [
      {
        label: 'Procedure codes',
        group: 'settings',
        routeId: 'codes',
        icon: 'list-checks',
        order: 950,
        permission: 'chart.view',
      },
    ],
    commands: [
      {
        id: 'codes.open',
        title: 'Procedure codes',
        keywords: [
          'cdt',
          'procedure codes',
          'autocode',
          'buttons',
          'fee schedules',
          'fees',
          'ucr',
          'ppo',
        ],
        routeId: 'codes',
        permission: 'chart.view',
      },
    ],
  }),
  pages: {
    codes: () => import('./CodesPage.js'),
  },
});
